import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoardHeroPanelComponent } from './board-hero-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [BoardHeroPanelComponent],
  exports: [BoardHeroPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class BoardHeroPanelModule { }
